import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import store from "./reducers/store";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { en, jp } from "./translations";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import "./scss/style.scss";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "jp",
  resources: {
    en: {
      language: en,
    },
    jp: {
      language: jp,
    }
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </Provider>
  // </React.StrictMode>
);

// reportWebVitals();
